module.exports = __webpack_public_path__ + "static/media/loading.7924d822.gif";